<header class="member-database-header flex align-items-center justify-content-between">
  <div class="logo ml-3 md:ml-5 flex align-items-center h-full">
    <a href="https://www.femmepalette.com/"><img class="logo flex" src="assets/FP-logo.png" alt="FP logo" /></a>
  </div>
  <fp-language-switcher></fp-language-switcher>
</header>

<main class="member-database-page">
  <div class="member-database-page__inner text-center md:text-left px-3 md:px-5">
    <ng-container *ngIf="loading">
      <p-progressSpinner></p-progressSpinner>
    </ng-container>

    <p *ngIf="errorMessage" class="p-error m-0">{{ errorMessage }}</p>

    <ng-container *ngIf="!loading && !errorMessage">
      <div class="member-database-page__layout">
        <div class="member-database-page__main">
          <span class="member-database-page__title block md:mb-4 mb-2">{{ 'MEMBER_DATABASE_PUBLIC.DEFAULT_TITLE' | translate }}</span>

          <div class="flex flex-column md:flex-row member-database-page__action-buttons-wrap md:mb-5 mb-3">
            <p-select
              [options]="countryOptions"
              [(ngModel)]="selectedCountry"
              [placeholder]="'MEMBER_DATABASE_PUBLIC.FILTER_COUNTRY' | translate"
              styleClass="member-filter"
              [showClear]="true"
              filterMatchMode="startsWith"
              [filter]="true"
              filterBy="label"
              (onChange)="onFilterChange()"
              (onClear)="onFilterChange()"
            ></p-select>

            <p-select
              [options]="fieldOptions"
              [(ngModel)]="selectedField"
              [placeholder]="'MEMBER_DATABASE_PUBLIC.FILTER_FIELD' | translate"
              styleClass="member-filter"
              [showClear]="true"
              (onChange)="onFilterChange()"
              (onClear)="onFilterChange()"
            ></p-select>
            <p-multiSelect
              inputId="interest_filter"
              [(ngModel)]="selectedInterests"
              [options]="interestOptions"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'MEMBER_DATABASE_PUBLIC.FILTER_INTEREST' | translate"
              styleClass="member-filter"
              [showClear]="true"
              clearIcon="pi pi-trash"
              appendTo="body"
              (onChange)="onFilterChange()"
              (onClear)="onFilterChange()"
            >
              <ng-template let-selectedItems pTemplate="selectedItems">
                <div class="interest-filter-tags" *ngIf="selectedItems?.length">
                  <span class="mb-1 p-tag member-interest-tag" *ngFor="let item of selectedItems">
                    {{ interestLabel(item) }}
                  </span>
                </div>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <span class="mb-1 p-tag member-interest-tag">{{ item.label }}</span>
              </ng-template>
            </p-multiSelect>
            <p-button
              styleClass="p-button-success member-filter-add text-20"
              class="member-filter-add-host md:ml-auto"
              [label]="'MEMBER_DATABASE_PUBLIC.ADD_PROFILE' | translate"
              (onClick)="showAddProfileDialog = true"
            ></p-button>
          </div>

          <div *ngIf="totalCount === 0" class="flex flex-column align-items-center justify-content-center gap-4 mt-6">
            <p class="text-color-secondary m-0 text-20">
              {{ 'MEMBER_DATABASE_PUBLIC.NO_PARTICIPANTS' | translate }}
            </p>
            <p-button
              styleClass="widescreen-only p-button-success"
              [label]="'MEMBER_DATABASE_PUBLIC.ADD_PROFILE' | translate"
              (onClick)="showAddProfileDialog = true"
            ></p-button>
          </div>

          <div class="grid" *ngIf="totalCount > 0">
            <article *ngFor="let p of members" class="col-12 lg:col-6 mb-1 flex">
              <div class="participant-card">
                <div class="participant-card__avatar-wrap">
                  <img *ngIf="p.member_photo" class="participant-card__avatar" [src]="p.member_photo" [alt]="p.member_name" />
                  <span *ngIf="!p.member_photo" class="participant-card__avatar-fallback">
                    {{ getInitials(p.member_name) }}
                  </span>
                  <ng-container *ngIf="linkedinHref(p) as href; else connectDisabled">
                    <a
                      pButton
                      class="participant-card__connect"
                      [ngClass]="{ 'participant-card__connect--clicked': isLinkedInClicked(p) }"
                      [href]="href"
                      target="_blank"
                      rel="noopener noreferrer"
                      [label]="
                        isLinkedInClicked(p)
                          ? ('MEMBER_DATABASE_PUBLIC.CONNECTED' | translate)
                          : ('MEMBER_DATABASE_PUBLIC.CONNECT' | translate)
                      "
                      (click)="onLinkedInClick(p)"
                    ></a>
                  </ng-container>
                  <ng-template #connectDisabled>
                    <button
                      pButton
                      type="button"
                      class="participant-card__connect"
                      [label]="'MEMBER_DATABASE_PUBLIC.CONNECT' | translate"
                      [disabled]="true"
                    ></button>
                  </ng-template>
                </div>
                <div class="participant-card__body">
                  <div class="participant-card__identity">
                    <div class="participant-card__location">
                      <i class="pi pi-map-marker"></i>
                      <span>{{ p.member_location }}</span>
                    </div>
                    <div class="participant-card__header-row">
                      <h2 class="participant-card__name m-0">{{ p.member_name }}</h2>
                      <span class="participant-card__field-tag" [attr.title]="p.member_field">{{ p.member_field }}</span>
                    </div>
                    <p class="participant-card__role m-0">{{ p.member_job_and_company }}</p>
                  </div>
                  <ng-container *ngIf="interestsList(p) as tags">
                    <div class="participant-card__tags" *ngIf="tags.length">
                      <span class="participant-card__tag" *ngFor="let tag of tags">{{ tag }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </article>
          </div>

          <p-paginator
            *ngIf="showPaginator"
            class="member-database-page__paginator flex justify-content-center mt-4"
            (onPageChange)="onPageChange($event)"
            [first]="first"
            [rows]="pageRows"
            [totalRecords]="totalCount"
            [showFirstLastIcon]="false"
          >
            <ng-template pTemplate="previouspagelinkicon">
              <span class="p-paginator-icon">{{ 'MEMBER_DATABASE_PUBLIC.PREVIOUS' | translate }}</span>
            </ng-template>
            <ng-template pTemplate="nextpagelinkicon">
              <span class="p-paginator-icon">{{ 'MEMBER_DATABASE_PUBLIC.NEXT' | translate }}</span>
            </ng-template>
          </p-paginator>
        </div>

        <aside class="member-database-page__sidebar">
          <div class="sidebar-inner">
            <h2 class="member-database-page__sidebar-title text-center">
              {{ 'MEMBER_DATABASE_PUBLIC.MORE_TIPS' | translate }}
            </h2>

            <div class="tip-card mb-6">
              <img class="tip-card__img" src="assets/mentoring.png" alt="" />
              <div class="tip-card__body">
                <h3 class="tip-card__title">{{ 'MEMBER_DATABASE_PUBLIC.TIP_MENTOR_TITLE' | translate }}</h3>
                <a
                  pButton
                  class="tip-card__btn"
                  href="https://www.femmepalette.com/mentoring-program"
                  target="_blank"
                  rel="noopener noreferrer"
                  [label]="'MEMBER_DATABASE_PUBLIC.TIP_MENTOR_CTA' | translate"
                ></a>
              </div>
            </div>

            <div class="tip-card">
              <img class="tip-card__img" src="assets/fp_attend_events.png" alt="" />
              <div class="tip-card__body">
                <h3 class="tip-card__title">{{ 'MEMBER_DATABASE_PUBLIC.TIP_EVENTS_TITLE' | translate }}</h3>
                <a
                  pButton
                  class="tip-card__btn"
                  href="https://www.femmepalette.com/events"
                  target="_blank"
                  rel="noopener noreferrer"
                  [label]="'MEMBER_DATABASE_PUBLIC.TIP_EVENTS_CTA' | translate"
                ></a>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </ng-container>

    <fp-member-database-add-new-profile
      [(visible)]="showAddProfileDialog"
      [fieldOptions]="fieldOptions"
      [countryOptions]="countryOptions"
      [interestOptions]="interestOptions"
      (profileSubmitted)="onProfileSubmitted()"
    ></fp-member-database-add-new-profile>
  </div>
</main>
